import {
  API_URLS,
  getJSONData,
  parseErrorMessage,
  TypeResponseError,
  TypeResponseSuccess,
} from '@/lib/api/config';

import { TypePauseReleaseResponseData } from '@/lib/api/subscriptionManager/types';

import { getAuthTokenClient } from '@/utils/helpers';

export type UnpauseSubEngineSubscriptionsParams = {
  subscriptionUuid: string;
  authToken?: string;
};

export const unpauseSubEngineSubscriptions = async ({
  subscriptionUuid,
  authToken,
}: UnpauseSubEngineSubscriptionsParams) => {
  const config = {
    method: 'POST',
    headers: {
      Authorization: authToken ?? (await getAuthTokenClient()),
      'Content-Type': 'application/json',
    },
  };

  const uri = `${API_URLS.SUBSCRIPTION_MANAGER_PROXY}/sub_engine/subscriptions/${subscriptionUuid}/pause_releases`;

  const response = await fetch(uri.toString(), config);

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeResponseSuccess<TypePauseReleaseResponseData>;
};
